"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardContextExternal = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var app_1 = require("../app");
var LeaderboardContextExternal = (function (_super) {
    tslib_1.__extends(LeaderboardContextExternal, _super);
    function LeaderboardContextExternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeaderboardContextExternal.prototype.sync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, ctx_id, e_1, users, key, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.social.inSolo) {
                            return [2, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        ctx_id = this.social.context_id;
                        return [4, this.appModel.post("scores-context/get", { ctx_id: ctx_id })];
                    case 2:
                        result = _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        utils_1.log.debug("failed to fetch", e_1);
                        return [2, false];
                    case 4:
                        users = this.social.friends.concat(this.social.me);
                        for (key in result) {
                            user = this.social.getFriendById(key, users);
                            if (user) {
                                user.scores.update(this.castLeaderboardEntry(result[key], user));
                            }
                        }
                        return [2, true];
                }
            });
        });
    };
    LeaderboardContextExternal.prototype.submit = function (score, extraData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, ctx_id, user_id, extData, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.social.inSolo) {
                            return [2, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        ctx_id = this.social.context_id;
                        user_id = this.social.me.id;
                        extData = typeof extraData === "string" ? extraData : JSON.stringify(extraData);
                        return [4, this.appModel.post("scores-context/post", {
                                ctx_id: ctx_id,
                                user_id: user_id,
                                score: score,
                                extData: extData
                            })];
                    case 2:
                        result = _a.sent();
                        return [3, 4];
                    case 3:
                        e_2 = _a.sent();
                        utils_1.log.debug("failed to fetch", e_2);
                        return [2, false];
                    case 4:
                        this.social.me.scores.update(this.castLeaderboardEntry(result, this.social.me));
                        return [2, true];
                }
            });
        });
    };
    LeaderboardContextExternal.prototype.castLeaderboardEntry = function (entry, userRef) {
        if (entry) {
            return {
                getScore: function () { return entry.score; },
                getFormattedScore: function () { return "".concat(entry.score); },
                getTimestamp: function () { return -1; },
                getRank: function () { return undefined; },
                getExtraData: function () { return entry.extData; },
                getPlayer: function () { return userRef.rawData; }
            };
        }
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.model),
        tslib_1.__metadata("design:type", app_1.AppModel)
    ], LeaderboardContextExternal.prototype, "appModel", void 0);
    tslib_1.__decorate([
        (0, core_1.lazyInject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], LeaderboardContextExternal.prototype, "social", void 0);
    LeaderboardContextExternal = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], LeaderboardContextExternal);
    return LeaderboardContextExternal;
}(core_1.EventDispatcher));
exports.LeaderboardContextExternal = LeaderboardContextExternal;
//# sourceMappingURL=LeaderboardContextExternal.js.map